export default __webpack_public_path__ + "static/desert-bc8e953d8583ae0c69cb29f93eb3156b.jpg";